import { useState } from "react";

export const useLocalStorage = (keyName, defaultValue) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const value = window.localStorage.getItem(keyName);

      if (value) {
        return JSON.parse(value);
      } else {
        window.localStorage.setItem(keyName, JSON.stringify(defaultValue));
        return defaultValue;
      }
    } catch (err) {
      return defaultValue;
    }
  });

  const setValue = (newValue) => {
    setStoredValue((currentValue) => {
      const resolvedValue =
        typeof newValue === "function" ? newValue(currentValue) : newValue;

      try {
        const nextSerialized =
          typeof resolvedValue === "string"
            ? resolvedValue
            : JSON.stringify(resolvedValue);
        const currentSerialized =
          typeof currentValue === "string"
            ? currentValue
            : JSON.stringify(currentValue);

        if (nextSerialized === currentSerialized) {
          return currentValue;
        }

        window.localStorage.setItem(keyName, nextSerialized);
      } catch (err) {}

      return resolvedValue;
    });
  };

  return [storedValue, setValue];
};
